export const iconFontAwesomeTextformattingBold = (
	<i className="fa-solid fa-bold"></i>
);
